import { render, staticRenderFns } from "./FeedMixer.vue?vue&type=template&id=2cd23a66"
import script from "./FeedMixer.vue?vue&type=script&lang=ts"
export * from "./FeedMixer.vue?vue&type=script&lang=ts"
import style0 from "./FeedMixer.vue?vue&type=style&index=0&id=2cd23a66&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports